import React from 'react';
import './style.css';
const Index = ({ front, back, sleeve, small }) => {
    return (
        <div className="shirt_design">
            <div className={`shirt_design_box ${small ? 'small' : ''}`}>
                <img src={front} alt="front" className={`shirt_design_img ${small ? 'small' : ''}`} />
                <p>Front</p>
            </div>
            <div className={`shirt_design_box ${small ? 'small' : ''}`}>
                <img src={back} alt="back" className={`shirt_design_img ${small ? 'small' : ''}`} />
                <p>Back</p>
            </div>
            <div className={`shirt_design_box ${small ? 'small' : ''}`}>
                <img src={sleeve} alt="sleeve" className={`shirt_design_img ${small ? 'small' : ''}`} />
                <p>Sleeve</p>
            </div>
        </div>
    );
};

export default Index;
